export const STEPS = [
  { id: "template", label: "Template", description: "Choose a starting template" },
  { id: "details", label: "Details", description: "Contract & supplier details" },
  { id: "deliverables", label: "Deliverables", description: "What needs to be delivered" },
  { id: "kpis", label: "KPIs", description: "Performance measures" },
  { id: "review", label: "Review", description: "Review and save" },
];

export const CONTRACT_TYPES = [
  "Service Agreement", "Non-Disclosure Agreement", "Licensing Agreement",
  "Consulting Agreement", "Vendor Agreement", "Employment Contract",
  "Partnership Agreement", "Sales Contract", "Lease Agreement", "Other",
];

export const DEPARTMENTS = [
  "IT", "Legal", "Finance", "Operations", "HR", "Marketing",
  "Procurement", "Sales", "Engineering", "Other",
];

export const SPEND_CATEGORIES = [
  "IT & Technology", "Professional Services", "Facilities & Maintenance",
  "Marketing & Advertising", "HR & Recruitment", "Legal Services",
  "Logistics & Transport", "Raw Materials", "Office Supplies",
  "Utilities & Energy", "Insurance", "Consulting", "Outsourcing & BPO",
  "Training & Development", "Travel & Expenses", "Capital Expenditure",
  "R&D", "Licensing & Subscriptions", "Other",
];

export const CURRENCIES = [
  "GBP", "USD", "EUR", "AED", "AUD", "BHD", "BRL", "CAD", "CHF", "CNY",
  "DKK", "EGP", "HKD", "IDR", "INR", "JPY", "KES", "KRW", "KWD", "MXN",
  "MYR", "NGN", "NOK", "NZD", "OMR", "PHP", "PLN", "QAR", "SAR", "SEK",
  "SGD", "THB", "TRY", "VND", "ZAR",
];

export function generateRecurringDates(startDate, recurrence, endDate) {
  if (!startDate || recurrence === "once") return [startDate].filter(Boolean);
  const dates = [];
  const end = endDate ? new Date(endDate) : new Date(new Date(startDate).getTime() + 365 * 24 * 60 * 60 * 1000);
  let current = new Date(startDate);
  const intervals = { weekly: 7, fortnightly: 14 };
  while (current <= end && dates.length < 104) {
    dates.push(current.toISOString().slice(0, 10));
    if (intervals[recurrence]) {
      current = new Date(current.getTime() + intervals[recurrence] * 24 * 60 * 60 * 1000);
    } else if (recurrence === "monthly") {
      current = new Date(current.getFullYear(), current.getMonth() + 1, current.getDate());
    } else if (recurrence === "quarterly") {
      current = new Date(current.getFullYear(), current.getMonth() + 3, current.getDate());
    } else if (recurrence === "biannually") {
      current = new Date(current.getFullYear(), current.getMonth() + 6, current.getDate());
    } else if (recurrence === "annually") {
      current = new Date(current.getFullYear() + 1, current.getMonth(), current.getDate());
    } else break;
  }
  return dates;
}
